import { render, staticRenderFns } from "./Staff07.vue?vue&type=template&id=0bd305f2&"
import script from "./Staff07.vue?vue&type=script&lang=js&"
export * from "./Staff07.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports